/** Format ISO timestamp as M/D/YY (no leading zeros). */
export function formatCreatedAt(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getMonth() + 1}/${d.getDate()}/${String(d.getFullYear() % 100).padStart(2, '0')}`;
}

/** `M/D/YY` and `HH:MM AM` halves of a timestamp, for callers that lay them out separately. */
export interface ShortDateTimeParts {
  readonly date: string;
  readonly time: string;
}

/** Split an ISO timestamp into `M/D/YY` + `HH:MM AM` (2-digit 12-hour clock, local time). Null when unparseable. */
export function formatDateTimeShortParts(iso: string): ShortDateTimeParts | null {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const hours24 = d.getHours();
  const meridiem = hours24 < 12 ? 'AM' : 'PM';
  const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;
  const hh = String(hours12).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return { date: formatCreatedAt(iso), time: `${hh}:${mm} ${meridiem}` };
}

/** Format ISO timestamp as `M/D/YY HH:MM AM` (2-digit 12-hour clock, local time). */
export function formatDateTimeShort(iso: string): string {
  const parts = formatDateTimeShortParts(iso);
  if (!parts) return '';
  return `${parts.date} ${parts.time}`;
}
